import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createHashHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { inputAnswerReducer } from '../features/question/inputAnswerSlice';
import { previewReducer } from '../features/preview/PreviewReducer';
import { appRootSaga } from './saga';
import { externalLinkReducer } from '../features/question/externalLinkSlice';

export const history = createHashHistory({});

const reducer = combineReducers({
  router: connectRouter(history),
  inputAnswer: inputAnswerReducer,
  preview: previewReducer,
  externalLink: externalLinkReducer,
});

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer,
  middleware(getDefaultMiddleware) {
    // https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['preview/cxSurveyPreviewModeHomeq'],
        ignoredActionPaths: [
          'preview/cxSurveyPreviewModeHomeq',
          'preview.coupon.imageUr',
        ],
        ignoredPaths: ['preview.coupon.imageUrl'],
      },
    })
      .concat(routerMiddleware(history))
      .concat(sagaMiddleware);
  },
});

sagaMiddleware.run(appRootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
